"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
ProfileAccessController.$inject = ['$scope', 'api', '_profile', 'notify', 'user'];
function ProfileAccessController($scope, api, _profile, notify, user) {
    $scope.user = _.create(user);
    $scope.save = function () {
        if ($scope.user.newPassword != $scope.user.newPasswordConfirm) {
            notify.error('Lozinke se ne poklapaju.');
            return;
        }
        _profile.saveUser($scope.user).then(function (response) {
            console.log(response);
            notify.success('Uspešno ste sačuvali podatke.');
        }, function (error) {
            console.log(error);
            notify.error(error.data);
        });
    };
}
exports.ProfileAccessController = ProfileAccessController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/profile/controllers/ProfileAccessController.js
// module id = 436
// module chunks = 0